import { Box } from "@mui/material";
import styled from "styled-components";
import SearchField from "../../../components/TextFields/SearchField/SearchField";
import Header from "../../../components/MarketPlace/Header/Header";
import { PrimaryButton } from "../../../components/Buttons/PrimaryButton/PrimaryButton";
import { ReactComponent as Filter } from "../../../assets/images/svg/filter.svg";

export const AdminPaymentPageContainer = styled(Box)`
  padding: 60px;
  padding-top: 38px;
  min-height: 100vh;
  padding-bottom: 100px;
  position: relative;
  @media (max-width: 600px) {
    padding: 18px;
    min-height: calc(100vh - 72px);
    padding-bottom: 100px;
    top: 65px;
  }
`;

export const AdminPaymentsSearchField = styled(SearchField)`
  top: -15px;

  @media (max-width: 900px) {
    margin-top: 72px;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

export const AdminPaymentsHeader = styled(Header)`
  /* top: 40px; */
  top: 0;
  @media (min-width: 600px) and (max-width: 900px) {
    & > div:nth-child(2) {
      display: none;
    }
  }
  @media (max-width: 600px) {
    top: 0;
    margin-top: 0px;
    & > div {
      margin-top: 0;
    }
    & > div > div > div {
      top: 25px;
      left: 0;
    }
  }
`;

export const PaymentsList = styled(Box)``;

export const NewPaymentButton = styled(PrimaryButton)`
  position: relative;
  margin-left: auto;
  height: 48px;
  width: 224px;
  & button {
    font-weight: 700;
  }
  @media (max-width: 600px) {
    /* bottom: 18px;
    right: 16px; */
  }
`;

export const FilterButtonContainer = styled(Box)`
  display: flex;
  justify-content: end;
  margin-top: 20px;
`;

export const FilterButton = styled(Box)`
  background-color: #e4e4e4;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FilterButtonIcon = styled(Filter)``;
